var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.appConstant.APP_VERSION_STATEMENT)+" "),_c('span',{staticClass:"bold-font"},[_vm._v(_vm._s(_vm.appVersion))])])
}
var staticRenderFns = []

export { render, staticRenderFns }